export default "__VITE_ASSET__0e29f88e__"